__turbopack_context__.v({
  "bottom": "footer-module__XhqkKq__bottom",
  "bottomLinks": "footer-module__XhqkKq__bottomLinks",
  "brand": "footer-module__XhqkKq__brand",
  "cIcon": "footer-module__XhqkKq__cIcon",
  "cLabel": "footer-module__XhqkKq__cLabel",
  "colTitle": "footer-module__XhqkKq__colTitle",
  "contactList": "footer-module__XhqkKq__contactList",
  "copyright": "footer-module__XhqkKq__copyright",
  "dirGrid": "footer-module__XhqkKq__dirGrid",
  "dirList": "footer-module__XhqkKq__dirList",
  "directory": "footer-module__XhqkKq__directory",
  "footer": "footer-module__XhqkKq__footer",
  "form": "footer-module__XhqkKq__form",
  "formCard": "footer-module__XhqkKq__formCard",
  "formError": "footer-module__XhqkKq__formError",
  "formGrid": "footer-module__XhqkKq__formGrid",
  "formSub": "footer-module__XhqkKq__formSub",
  "formSuccess": "footer-module__XhqkKq__formSuccess",
  "formTitle": "footer-module__XhqkKq__formTitle",
  "groupLabel": "footer-module__XhqkKq__groupLabel",
  "honeypot": "footer-module__XhqkKq__honeypot",
  "inner": "footer-module__XhqkKq__inner",
  "logo": "footer-module__XhqkKq__logo",
  "officeHint": "footer-module__XhqkKq__officeHint",
  "officeList": "footer-module__XhqkKq__officeList",
  "officeName": "footer-module__XhqkKq__officeName",
  "officeNote": "footer-module__XhqkKq__officeNote",
  "officePin": "footer-module__XhqkKq__officePin",
  "officeStatic": "footer-module__XhqkKq__officeStatic",
  "sendButton": "footer-module__XhqkKq__sendButton",
  "social": "footer-module__XhqkKq__social",
  "tagline": "footer-module__XhqkKq__tagline",
  "top": "footer-module__XhqkKq__top",
  "turnstileSlot": "footer-module__XhqkKq__turnstileSlot",
});
